import { ApplePackageManagers } from 'client/util/Constants';
import { EOL, EOS, applicationModelNames } from 'client/util/Constants/ApplicationConstants';
import moment from 'moment';

const {
  appleCustom,
  appleVpp,
} = ApplePackageManagers;

const ApplicationsFilters = {
  // Application Status
  appStatusActive: () => ({
    name: 'status',
    operator: 'eq',
    value: 'active',
    type: 'application status',
    displayValue: 'active',
  }),
  appStatusError: () => ([
    {
      name: 'status',
      operator: 'eq',
      value: EOL,
      type: 'application status',
      displayValue: 'error',
    },
  ]),
  appStatusWarning: () => ([
    {
      name: 'status',
      operator: 'eq',
      value: EOS,
      type: 'application status',
      displayValue: 'warning',
    },
  ]),
  appStatusDeactivated: () => ({
    name: 'status',
    operator: 'eq',
    value: 'deactivated',
    type: 'application status',
    displayValue: 'deactivated',
  }),
  // Application Type
  applicationTypePreconfigured: () => ({
    name: 'name',
    operator: 'ne',
    value: `${applicationModelNames.SAML2},name:ne:${applicationModelNames.BOOKMARK}`,
    type: 'application type',
    displayValue: 'SAML 2.0 (preconfigured)',
  }),
  applicationTypeCustom: () => ({
    name: 'name',
    operator: 'eq',
    value: applicationModelNames.SAML2,
    type: 'application type',
    displayValue: 'SAML 2.0 (custom)',
  }),
  applicationTypeBookmark: () => ({
    name: 'name',
    operator: 'eq',
    value: applicationModelNames.BOOKMARK,
    type: 'application type',
    displayValue: 'Bookmark',
  }),
  location: (value) => {
    let packageManager;

    if (value === 'Apple Business Manager') {
      packageManager = appleVpp;
    } else if (value === 'Self-Hosted') {
      packageManager = appleCustom;
    } else {
      packageManager = '';
    }

    return {
      name: 'packageManager',
      operator: 'eq',
      value: packageManager,
      type: 'location',
      displayValue: value,
    };
  },
  supportedDeviceFamilies: (model) => {
    const value = model;

    return {
      name: 'supportedDeviceFamilies',
      operator: 'in',
      value,
      type: 'device',
      displayValue: value,
    };
  },
  // Supported Functionality
  supFunctionalityJIT: () => ([
    {
      name: 'sso.jit.supported',
      operator: 'eq',
      value: true,
      type: 'supported functionality',
      displayValue: 'JIT Provisioning',
    },
  ]),
  supFunctionalitySAML: () => ({
    name: 'provision',
    operator: 'ne',
    value: null,
    type: 'supported functionality',
    displayValue: 'Identity Management',
  }),
  // SAML Certificate Status
  samlCertStatusActive: () => ([
    {
      name: 'sso.idpCertExpirationAt',
      operator: 'gt',
      value: moment().add(61, 'days').valueOf(),
      type: 'SAML certificate status',
      displayValue: 'active',
    },
  ]),
  samlCertStatusExpiring: () => ([
    {
      name: 'sso.idpCertExpirationAt',
      operator: 'lt',
      value: moment().add(61, 'days').valueOf(),
      type: 'SAML certificate status',
      displayValue: 'expiring soon',
    },
    {
      name: 'sso.idpCertExpirationAt',
      operator: 'gt',
      value: moment().valueOf(),
      type: 'SAML certificate status',
      displayValue: 'expiring soon',
    },
  ]),
  samlCertStatusExpired: () => ([
    {
      name: 'sso.idpCertExpirationAt',
      operator: 'lt',
      value: moment().valueOf(),
      type: 'SAML certificate status',
      displayValue: 'expired',
    },
  ]),
};

export default ApplicationsFilters;
